import type { ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { CallLog } from '../../../../../dialer/types/call-logs';
import { RequestStatus } from '../../../../../../shared/enums/request-status';
import { RootState } from '../../../../../../store/root-reducer';
import {
  AddToStepParams,
  SelectedProspectData,
  AttachmentDeletePayload,
  ContactListParams,
} from '../../../../../sequence/types';
import {
  unsubscribeProspectRequest,
  addToStepRequest,
  removeProspectRequest,
  getSingleProspectSequencesDetailsRequest,
  singleProspectSequencesMarkAsRepliedRequest,
  singleProspectRemoveFromSequencesRequest,
  saveContactAttributesRequest,
  getSingleProspectDetailsRequest,
  singleProspectSequencesMarkAsFinishedRequest,
  changePrimaryEmailInProspectRequest,
  deleteSecondaryEmailRequest,
  deleteSecondaryPhoneRequest,
  getTagsRequest,
  addTagsToProspectsRequest,
  updatePrimaryNumberRequest,
  createProspectNotesListRequest,
  updateProspectNoteRequest,
  getFieldsRequest,
  getSinglePropsectDetailPinnedFieldsRequest,
  updateProspectPinStatusRequest,
  updateProspectFieldByIdRequest,
  getProspectListRequest,
  getContactListByViewIdRequest,
  getSequenceListRequest,
  getStepListRequest,
  removeTagsFromProspectsRequest,
  getProspectListCountRequest,
  getProspectActivityCountRequest,
} from '../../../../extra-actions';
import {
  getTasksRequest,
  updateTasksRequest,
  getUndoTasksRequest,
  createTaskRequest,
  getShareableTaskerDataRequest,
  getWhatsappLinkRequest,
} from '../../../../../tasks/extra-actions';
import {
  getTaskAssigneeListRequest,
  uploadAttachmentRequest,
  deleteAttachmentRequest,
  imageUploadRequest,
  getSequenceContactListRequest,
} from '../../../../../sequence/extra-actions';
import {
  resetUploadAttachmentRequest,
  resetDeleteAttachmentRequest,
} from '../../../../../sequence/sequence-slice';
import { GetTasksParams, UpdateTask } from '../../../../../tasks/utils/types';
import { SequenceStepType } from '../../../../../sequence/enums';
import {
  resetProspectDeleteEmailRequestStatus,
  resetProspectDeletePhoneRequestStatus,
  resetRemoveProspectRequest,
  resetSaveContactAttributesRequestStatus,
  resetSequenceAndStepData,
  resetProspectPrimaryEmailChangeRequestStatus,
  resetTags,
  resetUpdatePrimaryNumberState,
  resetCreateProspectNotesListRequest,
  resetUpdateProspectNoteRequest,
  setProspectToNavigateFromModal,
  appendProspectIdsToNavigateFromModal,
  resetUpdateProspectFieldByIdRequest,
  setProspectViewIdFilter,
  setProspectActivityCount,
  resetLoadedSkeletonForCurrrentProspect,
  resetGetSingleProspectSequencesDetailsRequest,
} from '../../../../prospect-slice';
import {
  AddTagsToProspectsPayload,
  markAsRepliedParam,
  removeFromSequenceParam,
  CreateProspectNoteProp,
  UpdateProspectNoteProps,
  UpdateProspectPinStatusProps,
  ProspectFieldPayload,
  ProspectListPayload,
  RemoveTagsFromProspectsPayload,
  FilterGroupLogicPayload,
} from '../../../../types';
import ProspectDetails from './prospect-details';
import {
  resetCreateTaskRequest,
  resetShareableTaskerState,
  resetGetWhatsappLinkState,
  resetGetTasksRequest,
} from '../../../../../tasks/tasks-slice';

const mapStateToProps = (state: RootState) => ({
  addToStepRequestStatus: state.prospect.addToStepRequest.status,
  addToStepRequestError: state.prospect.addToStepRequest.error,
  addToStepRequestMessage: state.prospect.addToStepRequest.message,
  addToStepRequestFailedCount:
    state.prospect.addToStepRequestResultCount.failed,
  addToStepRequestSuccessfulCount:
    state.prospect.addToStepRequestResultCount.successful,

  removeProspectStatus: state.prospect.removeProspectRequest.status,
  removeProspectError: state.prospect.removeProspectRequest.error,
  removeProspectMessage: state.prospect.removeProspectRequest.message,

  unsubscribeProspectStatus: state.prospect.unsubscribeProspectRequest.status,
  unsubscribeProspectError: state.prospect.unsubscribeProspectRequest.error,
  unsubscribeProspectMessage: state.prospect.unsubscribeProspectRequest.message,

  markAsRepliedError:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.error,
  markAsRepliedMessage:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.message,
  markAsRepliedStatus:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.status,

  markAsFinishedError:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.error,
  markAsFinishedMessage:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.message,
  markAsFinishedStatus:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.status,

  removeFromSequenceStatus:
    state.prospect.singleProspectRemoveFromSequencesRequest.status,
  removeFromSequenceError:
    state.prospect.singleProspectRemoveFromSequencesRequest.error,
  removeFromSequenceMessage:
    state.prospect.singleProspectRemoveFromSequencesRequest.message,

  deleteSecondaryEmailRequestStatus:
    state.prospect.deleteSecondaryEmailRequest.status,
  deleteSecondaryEmailRequestError:
    state.prospect.deleteSecondaryEmailRequest.error,
  deleteSecondaryEmailRequestMessage:
    state.prospect.deleteSecondaryEmailRequest.message,

  deleteSecondaryPhoneRequestStatus:
    state.prospect.deleteSecondaryPhoneRequest.status,
  deleteSecondaryPhoneRequestError:
    state.prospect.deleteSecondaryPhoneRequest.error,
  deleteSecondaryPhoneRequestMessage:
    state.prospect.deleteSecondaryPhoneRequest.message,

  primaryEmailChangeRequestStatus:
    state.prospect.changePrimaryEmailInProspectRequest.status,
  primaryEmailChangeRequestError:
    state.prospect.changePrimaryEmailInProspectRequest.error,
  primaryEmailChangeRequestMessage:
    state.prospect.changePrimaryEmailInProspectRequest.message,

  primaryPhoneChangeRequestStatus:
    state.prospect.updatePrimaryNumberRequest.status,
  primaryPhoneChangeRequestError:
    state.prospect.updatePrimaryNumberRequest.error,
  primaryPhoneChangeRequestMessage:
    state.prospect.updatePrimaryNumberRequest.message,

  saveContactAttributesRequestStatus:
    state.prospect.saveContactAttributesRequest.status,
  saveContactAttributesRequestError:
    state.prospect.saveContactAttributesRequest.error,
  saveContactAttributesRequestMessage:
    state.prospect.saveContactAttributesRequest.message,
  allOutcomes: state.customOutcome.outcomes,
  tags: state.prospect.tags,
  fields: state.prospect.fields,
  addTagsToProspectsRequestStatus:
    state.prospect.addTagsToProspectsRequest.status,
  getTasksRequestStatus: state.tasks.getTasksRequest.status,
  tasks: state.tasks.prospectTasks,
  taskActionRequestStatus: state.tasks.updateTasksRequest.status,
  taskActionRequestMessage: state.tasks.updateTasksRequest.message,
  getUndoTasksRequestStatus: state.tasks.getUndoTasksRequest.status,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  createTaskRequestMessage: state.tasks.createTaskRequest.message,
  createTaskRequestError: state.tasks.createTaskRequest.error,
  taskAssigneeList: state.sequence.taskAssigneeList,
  userId: state.home.userId,
  uploadAttachmentRequestStatus:
    state.sequence?.uploadAttachmentRequest?.status,
  uploadAttachmentRequestError: state.sequence?.uploadAttachmentRequest?.error,
  uploadedAttachment: state.sequence?.uploadedAttachment,
  deleteAttachmentRequestStatus:
    state.sequence?.deleteAttachmentRequest?.status,
  deleteAttachmentRequestError: state.sequence?.deleteAttachmentRequest?.error,
  deletedAttachmentId: state.sequence?.deletedAttachmentId,
  shareableTaskerData: state.tasks.shareableTaskerData,
  getShareableTaskerDataRequestStatus:
    state.tasks.getShareableTaskerDataRequest.status,
  getWhatsappLinkRequestStatus: state.tasks.getWhatsappLinkRequest.status,
  getWhatsappLinkResponse: state.tasks.getWhatsappLinkResponse,
  createProspectNoteRequestStatus:
    state.prospect.createProspectNotesListRequest.status,
  createProspectNoteRequestMessage:
    state.prospect.createProspectNotesListRequest.message,
  createProspectNoteResponse: state.prospect.createProspectNoteResponse,
  updateProspectNoteRequestStatus:
    state.prospect.updateProspectNoteRequest.status,
  prospectToNavigateFromModal: state?.prospect?.prospectToNavigateFromModal,
  getSingleProspect: state?.prospect?.getSingleProspect,
  filters: state?.prospect?.filters,
  selectedSavedView: state?.prospect?.selectedSavedView,
  getProspectListRequestStatus: state?.prospect?.getProspectListRequest?.status,
  getContactListByViewIdRequestStatus:
    state?.prospect?.getContactListByViewIdRequest?.status,
  getSequenceContactListRequestStatus:
    state?.sequence?.getSequenceContactListRequest?.status,
  prospects: state?.prospect?.prospects || [],
  prospectKanbanData: state?.prospect?.prospectKanbanData || {},
  prospectKanbanViewData: state?.prospect?.prospectKanbanViewData || {},
  selectedKanbanCategoryId: state?.prospect?.selectedKanbanCategoryId,
  activeViewId: state?.prospect?.activeViewId,
  sequenceProspects: state?.sequence?.contacts,
  sequenceProspectsCount: state?.sequence?.sequenceProspectsCount || 0,
  prospectCount: state?.prospect?.prospectCount || 0,
  prospectKanbanCount: state?.prospect?.prospectKanbanCount || {},
  removeTagsFromProspectsRequestStatus:
    state.prospect.removeTagsFromProspectsRequest.status,
  sendAddTagsToProspectsRequestStatus:
    state.prospect.addTagsToProspectsRequest.status,
  sendRemoveTagsFromProspectsRequestStatus:
    state.prospect.removeTagsFromProspectsRequest.status,
  getProspectActivityCountRequestStatus:
    state.prospect.getProspectActivityCountRequest.status,
  prospectActivityCount: state?.prospect?.prospectActivityCount,
  isDemoAccount: state?.home?.isDemoAccount,
  myPhoneNumbersList: state?.dialer?.myPhoneNumbersList,
});

const mapDispatchToProps = {
  sendAddContactToStepRequest: (payload: AddToStepParams) =>
    addToStepRequest(payload),
  resetSequenceAndStepData: () => resetSequenceAndStepData(),
  sendRemoveProspectRequest: (contactArr: number[]) =>
    removeProspectRequest(contactArr),
  sendUnsubscribeProspectRequest: (contactArr: number[]) =>
    unsubscribeProspectRequest(contactArr),
  sendGetSingleProspectSequencesDetailsRequest: (contactArr: number) =>
    getSingleProspectSequencesDetailsRequest(contactArr),
  sendSequenceMarkAsRepliedRequest: (contactAndStepIds: markAsRepliedParam[]) =>
    singleProspectSequencesMarkAsRepliedRequest(contactAndStepIds),
  sendSequenceMarkAsFinishedRequest: (
    contactAndStepIds: markAsRepliedParam[],
  ) => singleProspectSequencesMarkAsFinishedRequest(contactAndStepIds),
  sendSingleProspectRemoveFromSequencesRequest: (
    param: removeFromSequenceParam,
  ) => singleProspectRemoveFromSequencesRequest(param),
  sendSaveContactAttributesRequest: (contactId: number, attributes: []) =>
    saveContactAttributesRequest({ contactId, attributes }),
  sendGetSingleProspectDetailsRequest: (contactId: number) =>
    getSingleProspectDetailsRequest(contactId),
  resetRemoveProspectRequest: () => resetRemoveProspectRequest(),
  resetSaveContactAttributesRequestStatus: () =>
    resetSaveContactAttributesRequestStatus(),
  sendPrimaryEmailChangeInProspectRequest: (
    primaryEmailProspectInfoId: number,
    contactId: number,
  ) =>
    changePrimaryEmailInProspectRequest({
      primaryEmailProspectInfoId,
      contactId,
    }),
  sendPrimaryPhoneChangeInProspectRequest: (
    primaryPhoneProspectInfoId: number,
    contactId: number,
  ) =>
    updatePrimaryNumberRequest({
      primaryPhoneProspectInfoId,
      contactId,
    }),
  resetUpdatePrimaryNumberState: () => resetUpdatePrimaryNumberState(),
  sendDeleteEmailFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryEmailRequest({ prospectInfoId, contactId }),
  sendDeletePhoneFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryPhoneRequest({ prospectInfoId, contactId }),
  resetProspectDeleteEmailRequestStatus: () =>
    resetProspectDeleteEmailRequestStatus(),
  resetProspectDeletePhoneRequestStatus: () =>
    resetProspectDeletePhoneRequestStatus(),
  resetProspectPrimaryEmailChangeRequestStatus: () =>
    resetProspectPrimaryEmailChangeRequestStatus(),
  sendGetTagsRequest: () => getTagsRequest(),
  sendAddTagsToProspectsRequest: (payload: AddTagsToProspectsPayload) =>
    addTagsToProspectsRequest(payload),
  resetTags: () => resetTags(),
  sendGetTasksRequest: (params: GetTasksParams) => getTasksRequest(params),
  sendUpdateTasksRequest: (payload: UpdateTask) => updateTasksRequest(payload),
  sendGetUndoTasksRequest: (params: GetTasksParams, taskId: number) =>
    getUndoTasksRequest({ params, taskId }),
  sendCreateTaskRequest: (payload: any) => createTaskRequest(payload),
  sendGetTaskAssigneeListRequest: () => getTaskAssigneeListRequest(),
  sendUploadAttachmentRequest: (payload: any) =>
    uploadAttachmentRequest(payload),
  sendDeleteAttachmentRequest: (payload: AttachmentDeletePayload) =>
    deleteAttachmentRequest(payload),
  sendImageUploadRequest: (payload: any) => imageUploadRequest(payload),
  resetUploadAttachmentRequest: () => resetUploadAttachmentRequest(),
  resetDeleteAttachmentRequest: () => resetDeleteAttachmentRequest(),
  resetCreateTaskRequest: () => resetCreateTaskRequest(),
  sendGetShareableTaskerDataRequest: (hashId: { hashId: string }) =>
    getShareableTaskerDataRequest(hashId),
  resetShareableTaskerState: () => resetShareableTaskerState(),
  sendGetWhatsappLinkRequest: (taskId: number) =>
    getWhatsappLinkRequest(taskId),
  resetGetWhatsappLinkState: () => resetGetWhatsappLinkState(),
  sendCreateProspectNoteRequest: (payload: CreateProspectNoteProp) =>
    createProspectNotesListRequest(payload),
  sendUpdateProspectNoteRequest: (payload: UpdateProspectNoteProps) =>
    updateProspectNoteRequest(payload),
  resetCreateProspectNotesListRequest: () =>
    resetCreateProspectNotesListRequest(),
  resetUpdateProspectNoteRequest: () => resetUpdateProspectNoteRequest(),
  getFieldsRequest: () => getFieldsRequest({}),
  getSinglePropsectDetailPinnedFieldsRequest: () =>
    getSinglePropsectDetailPinnedFieldsRequest(),
  updateProspectPinStatusRequest: (payload: UpdateProspectPinStatusProps) =>
    updateProspectPinStatusRequest(payload),
  sendUpdateProspectFieldByIdRequest: (payload: ProspectFieldPayload) =>
    updateProspectFieldByIdRequest(payload),
  setProspectToNavigateFromModal: (payload: {
    ids: number[];
    columnName: string;
  }) => setProspectToNavigateFromModal(payload),
  appendProspectIdsToNavigateFromModal: (ids: number[]) =>
    appendProspectIdsToNavigateFromModal(ids),
  sendGetProspectListRequest: (payload: ProspectListPayload) =>
    getProspectListRequest(payload),
  sendGetContactListByViewIdRequest: (payload: ProspectListPayload) =>
    getContactListByViewIdRequest(payload),
  resetUpdateProspectFieldByIdRequest: () =>
    resetUpdateProspectFieldByIdRequest(),
  getSequenceContactListRequest: (
    sequenceId: string,
    params: ContactListParams,
  ) =>
    getSequenceContactListRequest({
      sequenceId,
      ...params,
    }),
  getSequenceListRequest: () => getSequenceListRequest(),
  getStepListRequest: (sequenceId: string) =>
    getStepListRequest({ sequenceId }),
  sendRemoveTagsFromProspectsRequest: (
    payload: RemoveTagsFromProspectsPayload,
  ) => removeTagsFromProspectsRequest(payload),
  sendGetProspectListCountRequest: (payload: ProspectListPayload) =>
    getProspectListCountRequest(payload),
  setProspectViewIdFilter: (payload: FilterGroupLogicPayload) =>
    setProspectViewIdFilter(payload),
  sendGetProspectActivityCountRequest: (prospectId: number) =>
    getProspectActivityCountRequest(prospectId),
  editProspectAcitivityCount: (payload: any) =>
    setProspectActivityCount(payload),
  resetLoadedSkeletonForCurrrentProspect: () =>
    resetLoadedSkeletonForCurrrentProspect(),
  resetGetSingleProspectSequencesDetailsRequest: () =>
    resetGetSingleProspectSequencesDetailsRequest(),
  resetGetTasksRequest: () => resetGetTasksRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onHide: VoidFunction;
  selectedProspectId: number;
  setSelectedProspectId?: (prospectId: number | null) => void;
  resetSelectedProspectId: VoidFunction;
  selectedProspectData: SelectedProspectData;
  selectedProspectSequences: any[];
  getSingleProspectDetailsStatus: RequestStatus;
  getSingleProspectSequencesDetailsStatus: RequestStatus;
  isTagsFilterApplied: boolean;
  t?: (x: string) => string;
  currentSequenceId?: number;
  defaultTab?: 'activity' | 'contacts';
  setShowGlobalRestrictionModal?: (taskType: SequenceStepType) => void;
  callLogsVariant?: boolean;
  callLogRow?: CallLog | null;
  callLogsProfileHeader?: ReactNode;
  prospectDetail?: string;
};

export default connector(ProspectDetails);
